module.exports = __webpack_public_path__ + "media/theme/tutorial__mobage--4--create-6205a860.png";